import axios from 'axios'
import { collection, getDocs, getFirestore, query, serverTimestamp, where } from 'firebase/firestore'
import { EmployeeSchema } from 'shared/types'
import {v4 as uuid} from 'uuid'

const addEmployee = async (employee_data:EmployeeSchema)=>{

    const url = "https://us-central1-the-shopkeeper.cloudfunctions.net/employee"

    employee_data = {
        ...employee_data,
        uid: uuid(),
        created_at: serverTimestamp()
    }

    try {

        const res = await axios.post(url, employee_data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        return res.status
        
    } catch (error) {
        throw error
    }
    
}

const deleteEmployee = async (employee_id:string)=>{

    try {

        await axios.delete(`https://us-central1-the-shopkeeper.cloudfunctions.net/employee/${employee_id}`)
        return
        
    } catch (error) {
        throw error
    }
    
}

const getEmployees = async (business_id:string)=>{

    try {

        const employees:EmployeeSchema[] = []

        const ref = collection(getFirestore(), "users")
        const q = query(ref, where("business_id", "==", business_id))

        const res = await getDocs(q)

        res.forEach((employee)=>{
            if(employee.exists()){
                employees.push({
                    ...employee.data() as EmployeeSchema,
                    uid: employee.id
                })
            }
        })

        return employees
        
    } catch (error) {
        throw error
    }
    
}


const Employee = {
    addEmployee,
    deleteEmployee,
    getEmployees
}

export default Employee